<template>
  <div class="flex flex-col items-center justify-center text-center gap-10 mb-12">
    <div class="border border-grey-dark-700 rounded-[10px] custom-shadow w-12 h-12 flex items-center justify-center">
      <component v-if="icon" :is="icon" class="w-6 h-6 text-base-white" />
      <img v-else :src="image" alt="" class="w-6 h-6" />
    </div>
    <h2 class="max-w-3xl text-3xl lg:text-4xl font-semibold text-white">
      {{ title }}
    </h2>
    <p v-if="description" class="max-w-3xl text-base lg:text-xl font-light text-grey-dark-300">
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

interface Props {
  icon?: Component;
  image?: string;
  title: string;
  description?: string;
}
defineProps<Props>();
</script>
